export default __webpack_public_path__ + "static/media/Group 11002_1.c36361cf.svg";